import { useMemo, useState } from 'react';
import { Payment, DescriptionCode } from '@lendica/utils';
import { usePaginatedPayments } from './usePaginatedPayments';

export const useActivityCenter = () => {
    const {
        payments: basePayments,
        isInitialLoading,
        isFetchingMore,
        hasNext,
        loadMore,
    } = usePaginatedPayments({ pageSize: 20 });

    const [selectedTransaction, setSelectedTransaction] = useState<Payment | null>(null);
    const [localLoading, setIsLoading] = useState(false);

    const payments = useMemo(
        () =>
            basePayments.filter(
                p =>
                    (p.description_code === DescriptionCode.CompanyCollection ||
                        p.description_code === DescriptionCode.CompanyDisburse) &&
                    p.resulting_status !== 'Cancelled'
            ),
        [basePayments]
    );

    return {
        // loading
        isInitialLoading,
        isFetchingMore,
        hasNext,
        loadMore,
        isLoading: isInitialLoading || localLoading,
        setIsLoading,
        // data
        payments,
        // selection
        selectedTransaction,
        setSelectedTransaction,
    };
};
